<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$props}>
    <path d="M6.75 9.5L8.25 11L11.25 8" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.65002 5.7499C1.65002 3.76168 3.2618 2.1499 5.25002 2.1499H12.75C14.7382 2.1499 16.35 3.76168 16.35 5.7499V13.2499C16.35 15.2381 14.7382 16.8499 12.75 16.8499H5.25002C3.2618 16.8499 1.65002 15.2381 1.65002 13.2499V5.7499ZM5.25002 3.3499C3.92454 3.3499 2.85002 4.42442 2.85002 5.7499V13.2499C2.85002 14.5754 3.92454 15.6499 5.25002 15.6499H12.75C14.0755 15.6499 15.15 14.5754 15.15 13.2499V5.7499C15.15 4.42442 14.0755 3.3499 12.75 3.3499H5.25002Z"
        fill="currentColor"
    />
</svg>
